import type { UserEncoded } from "@silversea-ssc/dotcom-api-types/AuthStatus";
import { isPresent } from "src/utils/checks";
import { getWebStorageItem } from "src/utils/web-storage";

export const CONSUMER_ID_KEY = "consumer_id";

export type User = UserEncoded;

export const isLoyaltyVsMember = (user: User) => isPresent(user.vsLoyaltyId);

export const getConsumerId = (): string | undefined =>
  getWebStorageItem("local", CONSUMER_ID_KEY) ?? undefined;
